<!-- =========================================
     HERO
     ========================================= -->
<section class="store-hero">

  <div class="store-hero-content">

    <span class="store-hero-breadcrumb">
      Inicio / Catálogo
    </span>

    <h1>
      Nuestro <em>catálogo</em>
    </h1>

    <p>
      Precios de lista vigentes. La disponibilidad varía por sucursal y
      temporada; confírmalo por WhatsApp antes de pasar.
    </p>

  </div>

</section>
<!-- =========================================
     PROMOCIONES
     ========================================= -->
<!-- <section class="promotions-section" *ngIf="banners.length > 0">
  <div class="promotions-header">
    <h2 class="promotions-title">
      <span class="nina-brand-italic">Promos</span>
      <span> de la semana</span>
    </h2>
    <button type="button" class="promotions-link" (click)="goToPromotions()">
      Ver el catálogo
      <span class="arrow">→</span>
    </button>
  </div>
  <owl-carousel-o [options]="promoOptions" class="promotions-carousel">
    <ng-container *ngFor="let banner of banners">
      <ng-template carouselSlide>
        <div class="promotion-card" (click)="goToBanner(banner)">
          <img [src]="banner.urlFotoParaMovil" [defaultImage]="defImgBanner" [alt]="banner.al" [title]="banner.al">
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
  <p class="promotions-disclaimer">
    Aplican restricciones. No válido en fechas especiales
    (San Valentín, Día de la Madre, Día del Padre, etc.).
  </p>
</section> -->
<!-- =========================================
     CONTENIDO DE TIENDA
     ========================================= -->
<section class="store-section">
  <!-- CATEGORÍAS -->
  <!-- <div class="store-lines" *ngIf="lines.length > 0">
    <button type="button" class="store-line" [class.active]="searchLine === 0" (click)="clearLineFilter()">
      TODOS
    </button>
    <button type="button" class="store-line" *ngFor="let line of lines" [class.active]="line.selected"
      (click)="selectLine(line)">
      {{ line.descripcion }}
    </button>
  </div> -->
  <!-- CATEGORÍAS -->
  <!-- CATEGORÍAS -->
  <div class="store-categories" *ngIf="lines.length > 0">
    <!-- Navegación en una fila independiente -->
    <div class="store-lines-navigation">
      <button type="button" class="store-lines-arrow" aria-label="Desplazar categorías a la izquierda"
        (click)="scrollLines('left')">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button type="button" class="store-lines-arrow" aria-label="Desplazar categorías a la derecha"
        (click)="scrollLines('right')">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>

    <!-- Scroll original de categorías -->
    <div class="store-lines" #linesContainer>
      <button type="button" class="store-line" [class.active]="searchLine === 0" (click)="clearLineFilter()">
        TODOS
      </button>
      <button type="button" class="store-line" *ngFor="let line of lines" [class.active]="line.selected"
        (click)="selectLine(line)">
        {{ line.descripcion }}
      </button>
    </div>
  </div>
  <!-- ENCABEZADO -->
  <div class="store-heading">
    <div>
      <span class="store-eyebrow">
        CATÁLOGO
      </span>
      <h1>
        {{ getStoreTitle() }}
      </h1>
      <p *ngIf="filteredProducts.length > 0">
        {{ filteredProducts.length }}
        productos disponibles
      </p>
    </div>
  </div>
  <!-- PRODUCTOS -->
  <div class="products-grid" *ngIf="products.length > 0">
    <div class="product-card-wrapper" *ngFor="let product of obs | async">
      <article class="product-card" (click)="selectedProduct(product)">
        <!-- IMAGEN -->
        <div class="product-image-container">
          <img class="product-image" [src]="product.urlFoto" [defaultImage]="defImgProd"
            [alt]="product.productoAgrupador" />
        </div>
        <!-- INFORMACIÓN -->
        <div class="product-content">
          <h2 class="product-description">
            {{ product.productoAgrupador }}
          </h2>
          <div class="product-bottom">
            <span class="product-price">
              Desde:
              {{ product.desde | currency:'USD':'symbol':'1.0-0' }}
            </span>
            <button type="button" class="product-button" (click)="selectedProduct(product); $event.stopPropagation()">
              Ver producto
            </button>
          </div>
        </div>
      </article>
    </div>
  </div>
  <!-- SIN PRODUCTOS -->
  <div class="empty-products" *ngIf="products.length > 0 && filteredProducts.length === 0">
    <img src="assets/iconos-nina-png/tinta/search.png" alt="" />
    <h2>
      No encontramos productos
    </h2>
    <p>
      Intenta con otra búsqueda o categoría.
    </p>
  </div>
  <!-- PAGINADOR -->
  <div class="store-pagination" *ngIf="products.length > 0">
    <mat-paginator [pageSizeOptions]="[16, 32, 64, 128]" (page)="pageEvent = $event" showFirstLastButtons>
      <span mat-paginator-page-size-label>
        Productos por página:
      </span>
    </mat-paginator>
  </div>
</section>